import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import { BrandCard } from '../../components/cards/BrandCard/BrandCard';

const ComposableFollowedBrandCard = ({ id, ...props }) => (
  <GridItem
    columnEndSm="span 12"
    columnEndMd="span 6"
    columnEndLg="span 4"
    columnEndXl="span 3"
    key={id}
  >
    <BrandCard {...props} />
  </GridItem>
);

ComposableFollowedBrandCard.propTypes = {
  id: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

export default ComposableFollowedBrandCard;
